/**
 * Publish state for a question in the bank / on a paper.
 *
 * A thin face on `lib/question-status`, kept so existing imports keep
 * working. The two states, their labels and their tones are defined there,
 * once.
 */

import {
  QUESTION_STATUSES,
  QUESTION_STATUS_ICON,
  QUESTION_STATUS_LABEL,
  QUESTION_STATUS_TONE,
  toQuestionStatus,
  type QuestionStatus,
} from "@/lib/question-status"

export const QUESTION_BANK_STATUSES = QUESTION_STATUSES

export type QuestionBankStatus = QuestionStatus

export const QUESTION_BANK_STATUS_TONE = QUESTION_STATUS_TONE

export const QUESTION_BANK_STATUS_ICON = QUESTION_STATUS_ICON

/** What the author sees. */
export const QUESTION_BANK_STATUS_LABEL = QUESTION_STATUS_LABEL

export function normalizeQuestionBankStatus(
  value: string | undefined | null
): QuestionBankStatus {
  return toQuestionStatus(value)
}
